import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'navaar-play-icon',
  template: `
  <div [style.right.%]="isSmall ? 5 : 14">
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="10 5 43.449 42.146">
    <path d="M17.8580054,10.232628 C19.5932811,11.2087206 19.5941297,12.7908021 17.8580054,13.767372 L8.14199463,19.232628 C6.40671891,20.2087206 5,19.3867791 5,17.400693 L5,6.59930697 C5,4.61146462 6.40587035,3.79080207 8.14199463,4.76737198 L17.8580054,10.232628 Z" transform="translate(17 15)" fill="#fff" /></svg>
    <svg [@showHeader] *ngIf="showLoader" width="40" height="40" viewBox="0 0 40 40" id="showLoaderButton">
      <circle fill="transparent" stroke-width="2" cx="25" cy="25" r="24" stroke="url(#garadient)" class="path"></circle>
      <svg class="spinner-dot dot" width="5px" height="5px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" x="31" y="-.8">
        <circle  fill="#fff" cx="44" cy="51" r="30" class="path"></circle>
        <linearGradient id="garadient">
          <stop offset="50%" stop-color="#fff" stop-opacity="1"/>
          <stop offset="65%" stop-color="#fff" stop-opacity=".5"/>
          <stop offset="100%" stop-color="#fff" stop-opacity="0"/>
        </linearGradient>
      </svg>
    </svg>
  </div>
`,
  styles: [
    `
      div{
        height: 100%;
        display: inline-block;
        vertical-align: middle;
      }
      #showLoaderButton {
        right: -2px;
      }
      #showLoaderButton .path{
        stroke-dasharray: 140;
        stroke-dashoffset: 17;
      }
      svg{
        fill: #ffffff;
      }`
  ],
  animations: [
    trigger('showHeader', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease', style({ opacity: 1 }))
      ])
    ])
  ]
})
export class PlayIconComponent {

  @Input('show-loader') public showLoader: boolean = false;
  @Input() public isSmall;
  constructor() { }
}
